
import { CHANGELOG } from "../../../models/changelog"
import { logUpsellSurfaceClicked } from "../../../models/analytics"
import { useUpsellImpression } from "../../../util/useUpsellImpression"
import { useTranslation } from "react-i18next"
import { useAuthContext } from "../../auth/AuthProvider"
import { useOwnerTier } from "../../flags/useOwnerTier"
import { pricingRouteHighlight, useRouteContext } from "../../route/RouteProvider"
import { SUPPORT_MAILTO } from "../../../util/supportUrl"

const HAS_PRO_FEATURE_IN_CHANGELOG = CHANGELOG.some((e) => e.features.some((f) => f.proFeature))

function formatDate(epoch: number): string {
  const d = new Date(epoch)
  const mm = String(d.getUTCMonth() + 1)
  const dd = String(d.getUTCDate())
  const yy = String(d.getUTCFullYear()).slice(-2)
  return `${mm}.${dd}.${yy}`
}

export const FeaturesModal = () => {
  const { t } = useTranslation()
  const [uid] = useAuthContext()
  const [tier, tierLoading] = useOwnerTier(uid ?? undefined)
  const [, setRoute] = useRouteContext()
  const showUpsell = !tierLoading && tier !== "pro"
  useUpsellImpression("features_modal", "pro", showUpsell && HAS_PRO_FEATURE_IN_CHANGELOG)

  return (
    <div className="box">
      <a
        className="button is-ghost is-pulled-right"
        href={SUPPORT_MAILTO}
        title="Send your Feedback"
      >
        <span className="icon is-medium has-text-dark">
          <i className="icon-post is-large" aria-hidden="true"></i>
        </span>
      </a>
      <p className="title">Recent Changes</p>
      {CHANGELOG.map((entry) => (
        <div key={entry.epoch}>
          <p className="subtitle mb-2 mt-5">
            <b className="has-text-info">{formatDate(entry.epoch)}</b>
          </p>
          {entry.features.map((feature) => (
            <div className="block" key={feature.title}>
              <b>- {feature.title}:</b> {feature.description}
              {feature.keys && (
                <ul>
                  {feature.keys.map((k) => (
                    <li key={k.label}>
                      <b className="has-text-success">[{k.label}]</b> {k.action}
                    </li>
                  ))}
                </ul>
              )}
              {feature.proFeature && showUpsell && (
                <div className="message is-success" style={{ marginTop: "0.5rem" }}>
                  <div className="message-body" style={{ padding: "0.75rem 1rem", display: "flex", alignItems: "center", gap: "0.75rem" }}>
                    <span className="icon" style={{ flexShrink: 0 }}>
                      <i className="icon-info" />
                    </span>
                    <span style={{ fontSize: "0.85rem", flex: 1 }}>
                      {t(feature.proHintKey ?? "pro.encryption.hint")}
                    </span>
                    <button
                      className="button is-small is-success"
                      onClick={() => {
                        logUpsellSurfaceClicked("features_modal", "pro")
                        setRoute(pricingRouteHighlight("pro", "features_modal"))
                      }}
                    >
                      {t("pro.cta")}
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
